// extracted by mini-css-extract-plugin
export default {"customOverlay":"AgreementPriceListTable_customOverlay__3RwCO"};